import HttpFactory from '@/mixins/http.factory';
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';
export default {
  mixins:[HttpFactory],
  name:'job-log-report',
  data () {
    return {
      data:[],
      columnDefs:[],
    }
  },
  created () {
    this.init();
  },
  methods: {
    init(){
      this.getJobLog(0,200);
    },
    async getJobLog(start,end){
      const _self=this;
      let data={};
      try{
        let response=await _self.post('jobreport',data);
        if(response && response.data){
            let logData=response.data.Data;
            _self.fn().sortNumCol(logData,'id')
            _self.data=logData;
        }else{
            _self.userMsg.list=['An error occurred!! Please try again later'];
        }
      }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
    },
  },
  components:{
    customAgGrid
  },
  beforeMount() {
    let _self  =this;
    _self.columnDefs = [
      { headerName: 'Run Id', field: 'runId',width: 150,cellClass:''},
      { headerName: 'Job Name', field: 'jobName', width: 200 },
      { headerName: 'Event Type', field: 'eventType', width: 150 },
      { headerName: 'Description', field: 'description', width:400 },
      { headerName: 'Created On', field: 'createdOn', width:150,cellRendererFramework:dateTimeRenderer }
    ];
  }
}
